import { render, staticRenderFns } from "./IconColorProperty.vue?vue&type=template&id=5fe9342e&"
import script from "./IconColorProperty.vue?vue&type=script&lang=js&"
export * from "./IconColorProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports